'use strict';

const makeItem = (entry) => {
    return {
        value: {
            system: 'http://snomed.info/sct',
            display: entry.display,
            code: entry.code.toString()
        },
        label: entry.label,
        mobileLabel: entry.mobileLabel,
        level: entry.level
    };
};

const codes = [
    {
        code: 54471007,
        display: 'Buccal route (qualifier value)',
        label: 'Buccal',
        mobileLabel: 'In the cheek',
        level: 1
    },
    {
        code: 418162004,
        display: 'Colostomy route (qualifier value)',
        label: 'Colostomy',
        mobileLabel: 'Via Colostomy',
        level: 1
    },
    {
        code: 404820008,
        display: 'Epidural route (qualifier value)',
        label: 'Epidural',
        mobileLabel: 'Epidurally',
        level: 1
    },
    {
        code: 78421000,
        display: 'Intramuscular use',
        label: 'Intramuscular',
        mobileLabel: 'In the muscle',
        level: 1
    },
    {
        code: 46713006,
        display: 'Nasal route (qualifier value)',
        label: 'Intranasal',
        mobileLabel: 'In the nose',
        level: 1
    },
    {
        code: 47625008,
        display: 'Intravenous route (qualifier value)',
        label: 'Intravenous',
        mobileLabel: 'Venously',
        level: 1
    },
    {
        code: 127492001,
        display: 'Nasogastric use',
        label: 'Nasogastric',
        mobileLabel: 'Via Nasal Tube',
        level: 1
    },
    {
        code: 54485002,
        display: 'Ophthalmic route (qualifier value)',
        label: 'Ocular',
        mobileLabel: 'In the eye',
        level: 1
    },
    {
        code: 26643006,
        display: 'Oral route (qualifier value)',
        label: 'Orally',
        mobileLabel: 'By mouth',
        level: 1
    },
    {
        code: 10547007,
        display: 'A route that begins on, in or by way of the ear.',
        label: 'Otic',
        mobileLabel: 'In ear',
        level: 1
    },
    {
        code: 127490009,
        display: 'Gastrostomy use',
        label: 'PEG',
        mobileLabel: 'Via Feeding Tube',
        level: 1
    },
    {
        code: 37161004,
        display: 'An intracolonic route that begins in the rectum.',
        label: 'Rectal',
        mobileLabel: 'Rectally',
        level: 1
    },
    {
        code: 34206005,
        display: 'Subcutaneous route (qualifier value)',
        label: 'Subcutaneous',
        mobileLabel: 'Under the skin',
        level: 1
    },
    {
        code: 37839007,
        display: 'Sublingual route (qualifier value)',
        label: 'Sublingual',
        mobileLabel: 'Under the tongue',
        level: 1
    },
    {
        code: 6064005,
        display: 'Topical route (qualifier value)',
        label: 'Topical',
        mobileLabel: 'On Skin',
        level: 1
    },
    {
        code: 90028008,
        display: 'Urethral route (qualifier value)',
        label: 'Urethral',
        mobileLabel: 'In the urethra',
        level: 1
    },
    {
        code: 16857009,
        display: 'Vaginal route (qualifier value)',
        label: 'Vaginal',
        mobileLabel: 'Vaginally',
        level: 1
    },
    {
        code: 697971008,
        display: 'Arteriovenous fistula route (qualifier value)',
        label: 'Arteriovenous fistula',
        mobileLabel: 'Arteriovenous fistula',
        level: 2
    },
    {
        code: 432671000124106,
        display: 'Arteriovenous graft route (qualifier value)',
        label: 'Arteriovenous graft',
        mobileLabel: 'Arteriovenous graft',
        level: 2
    },
    {
        code: 420254004,
        display: 'Body cavity route (qualifier value)',
        label: 'Body cavity',
        mobileLabel: 'Body cavity',
        level: 2
    },
    {
        code: 417070009,
        display: 'Caudal route (qualifier value)',
        label: 'Caudal',
        mobileLabel: 'Caudal',
        level: 2
    },
    {
        code: 446105004,
        display: 'Conjunctival route (qualifier value)',
        label: 'Conjunctival',
        mobileLabel: 'Conjunctival',
        level: 2
    },
    {
        code: 448598008,
        display: 'Cutaneous route (qualifier value)',
        label: 'Cutaneous',
        mobileLabel: 'Cutaneous',
        level: 2
    },
    {
        code: 372449004,
        display: 'Dental route (qualifier value)',
        label: 'Dental',
        mobileLabel: 'Dental',
        level: 2
    },
    {
        code: 447964005,
        display: 'Digestive tract route (qualifier value)',
        label: 'Digestive tract',
        mobileLabel: 'Digestive tract',
        level: 2
    },
    {
        code: 372450004,
        display: 'Endocervical route (qualifier value)',
        label: 'Endocervical',
        mobileLabel: 'Endocervical',
        level: 2
    },
    {
        code: 372451000,
        display: 'Endosinusial route (qualifier value)',
        label: 'Endosinusial',
        mobileLabel: 'Endosinusial',
        level: 2
    },
    {
        code: 372452007,
        display: 'Endotracheopulmonary route (qualifier value)',
        label: 'Endotracheopulmonary',
        mobileLabel: 'Endotracheopulmonary',
        level: 2
    },
    {
        code: 417985001,
        display: 'Enteral route (qualifier value)',
        label: 'Enteral',
        mobileLabel: 'Enteral',
        level: 2
    },
    {
        code: 420163009,
        display: 'Esophagostomy route (qualifier value)',
        label: 'Esophagostomy',
        mobileLabel: 'Esophagostomy',
        level: 2
    },
    {
        code: 372453002,
        display: 'Extra-amniotic route (qualifier value)',
        label: 'Extra-amniotic',
        mobileLabel: 'Extra-amniotic',
        level: 2
    },
    {
        code: 418743005,
        display: 'Fistula route (qualifier value)',
        label: 'Fistula',
        mobileLabel: 'Fistula',
        level: 2
    },
    {
        code: 418136008,
        display: 'Gastro-intestinal stoma route (qualifier value)',
        label: 'Gastro-intestinal stoma',
        mobileLabel: 'Gastro-intestinal stoma',
        level: 2
    },
    {
        code: 372454008,
        display: 'Gastroenteral route (qualifier value)',
        label: 'Gastroenteral',
        mobileLabel: 'Gastroenteral',
        level: 2
    },
    {
        code: 372457001,
        display: 'Gingival route (qualifier value)',
        label: 'Gingival',
        mobileLabel: 'Gingival',
        level: 2
    },
    {
        code: 419954003,
        display: 'Ileostomy route (qualifier value)',
        label: 'Ileostomy',
        mobileLabel: 'Ileostomy',
        level: 2
    },
    {
        code: 429817007,
        display: 'Interstitial route (qualifier value)',
        label: 'Interstitial',
        mobileLabel: 'Interstitial',
        level: 2
    },
    {
        code: 58100008,
        display: 'Intra-arterial route (qualifier value)',
        label: 'Intra-arterial',
        mobileLabel: 'Intra-arterial',
        level: 2
    },
    {
        code: 12130007,
        display: 'Intra-articular route (qualifier value)',
        label: 'Intra-articular',
        mobileLabel: 'Intra-articular',
        level: 2
    },
    {
        code: 419396008,
        display: 'Intraabdominal route (qualifier value)',
        label: 'Intraabdominal',
        mobileLabel: 'Intraabdominal',
        level: 2
    },
    {
        code: 372458006,
        display: 'Intraamniotic route (qualifier value)',
        label: 'Intraamniotic',
        mobileLabel: 'Intraamniotic',
        level: 2
    },
    {
        code: 404819002,
        display: 'Intrabiliary route (qualifier value)',
        label: 'Intrabiliary',
        mobileLabel: 'Intrabiliary',
        level: 2
    },
    {
        code: 372459003,
        display: 'Intrabursal route (qualifier value)',
        label: 'Intrabursal',
        mobileLabel: 'Intrabursal',
        level: 2
    },
    {
        code: 418821007,
        display: 'Intracameral route (qualifier value)',
        label: 'Intracameral',
        mobileLabel: 'Intracameral',
        level: 2
    },
    {
        code: 372460008,
        display: 'Intracardiac route (qualifier value)',
        label: 'Intracardiac',
        mobileLabel: 'Intracardiac',
        level: 2
    },
    {
        code: 418331006,
        display: 'Intracartilaginous route (qualifier value)',
        label: 'Intracartilaginous',
        mobileLabel: 'Intracartilaginous',
        level: 2
    },
    {
        code: 372461007,
        display: 'Intracavernous route (qualifier value)',
        label: 'Intracavernous',
        mobileLabel: 'Intracavernous',
        level: 2
    },
    {
        code: 446540005,
        display: 'Intracerebral route (qualifier value)',
        label: 'Intracerebral',
        mobileLabel: 'Intracerebral',
        level: 2
    },
    {
        code: 420719007,
        display: 'Intracerebroventricular route (qualifier value)',
        label: 'Intracerebroventricular',
        mobileLabel: 'Intracerebroventricular',
        level: 2
    },
    {
        code: 418892005,
        display: 'Intracisternal route (qualifier value)',
        label: 'Intracisternal',
        mobileLabel: 'Intracisternal',
        level: 2
    },
    {
        code: 448492006,
        display: 'Intracolonic route (qualifier value)',
        label: 'Intracolonic',
        mobileLabel: 'Intracolonic',
        level: 2
    },
    {
        code: 418608002,
        display: 'Intracorneal route (qualifier value)',
        label: 'Intracorneal',
        mobileLabel: 'Intracorneal',
        level: 2
    },
    {
        code: 418287000,
        display: 'Intracoronal route (qualifier value)',
        label: 'Intracoronal',
        mobileLabel: 'Intracoronal',
        level: 2
    },
    {
        code: 372463005,
        display: 'Intracoronary route (qualifier value)',
        label: 'Intracoronary',
        mobileLabel: 'Intracoronary',
        level: 2
    },
    {
        code: 445769006,
        display: 'Intracorpus cavernosum route',
        label: 'Intracorpus cavernosum',
        mobileLabel: 'Intracorpus cavernosum',
        level: 2
    },
    {
        code: 418987007,
        display: 'Intracranial route (qualifier value)',
        label: 'Intracranial',
        mobileLabel: 'Intracranial',
        level: 2
    },
    {
        code: 372464004,
        display: 'Intradermal route (qualifier value)',
        label: 'Intradermal',
        mobileLabel: 'Intradermal',
        level: 2
    },
    {
        code: 372465003,
        display: 'Intradiscal route (qualifier value)',
        label: 'Intradiscal',
        mobileLabel: 'Intradiscal',
        level: 2
    },
    {
        code: 417989007,
        display: 'Intraductal route (qualifier value)',
        label: 'Intraductal',
        mobileLabel: 'Intraductal',
        level: 2
    },
    {
        code: 418887008,
        display: 'Intraduodenal route (qualifier value)',
        label: 'Intraduodenal',
        mobileLabel: 'Intraduodenal',
        level: 2
    },
    {
        code: 445756007,
        display: 'Intradural route (qualifier value)',
        label: 'Intradural',
        mobileLabel: 'Intradural',
        level: 2
    },
    {
        code: 446407004,
        display: 'Intraepicardial route (qualifier value)',
        label: 'Intraepicardial',
        mobileLabel: 'Intraepicardial',
        level: 2
    },
    {
        code: 448077001,
        display: 'Intraepidermal route (qualifier value)',
        label: 'Intraepidermal',
        mobileLabel: 'Intraepidermal',
        level: 2
    },
    {
        code: 445752009,
        display: 'Intraesophageal route (qualifier value)',
        label: 'Intraesophageal',
        mobileLabel: 'Intraesophageal',
        level: 2
    },
    {
        code: 445768003,
        display: 'Intragastric route',
        label: 'Intragastric',
        mobileLabel: 'Intragastric',
        level: 2
    },
    {
        code: 445754005,
        display: 'Intragingival route (qualifier value)',
        label: 'Intragingival',
        mobileLabel: 'Intragingival',
        level: 2
    },
    {
        code: 445941009,
        display: 'Intrahepatic route (qualifier value)',
        label: 'Intrahepatic',
        mobileLabel: 'Intrahepatic',
        level: 2
    },
    {
        code: 447026006,
        display: 'Intraileal route (qualifier value)',
        label: 'Intraileal',
        mobileLabel: 'Intraileal',
        level: 2
    },
    {
        code: 448491004,
        display: 'Intrajejunal route (qualifier value)',
        label: 'Intrajejunal',
        mobileLabel: 'Intrajejunal',
        level: 2
    },
    {
        code: 372466002,
        display: 'Intralesional route (qualifier value)',
        label: 'Intralesional',
        mobileLabel: 'Intralesional',
        level: 2
    },
    {
        code: 445913005,
        display: 'Intralingual route (qualifier value)',
        label: 'Intralingual',
        mobileLabel: 'Intralingual',
        level: 2
    },
    {
        code: 37737002,
        display: 'Intraluminal route (qualifier value)',
        label: 'Intraluminal',
        mobileLabel: 'Intraluminal',
        level: 2
    },
    {
        code: 372467006,
        display: 'Intralymphatic route (qualifier value)',
        label: 'Intralymphatic',
        mobileLabel: 'Intralymphatic',
        level: 2
    },
    {
        code: 447121004,
        display: 'Intramammary route (qualifier value)',
        label: 'Intramammary',
        mobileLabel: 'Intramammary',
        level: 2
    },
    {
        code: 60213007,
        display: 'Intramedullary route (qualifier value)',
        label: 'Intramedullary',
        mobileLabel: 'Intramedullary',
        level: 2
    },
    {
        code: 445767008,
        display: 'Intrameningeal route (qualifier value)',
        label: 'Intrameningeal',
        mobileLabel: 'Intrameningeal',
        level: 2
    },
    {
        code: 711378007,
        display: 'Intramural route (qualifier value)',
        label: 'Intramural',
        mobileLabel: 'Intramural',
        level: 2
    },
    {
        code: 418133000,
        display: 'Intramyometrial route (qualifier value)',
        label: 'Intramyometrial',
        mobileLabel: 'Intramyometrial',
        level: 2
    },
    {
        code: 711360002,
        display: 'Intraneural route (qualifier value)',
        label: 'Intraneural',
        mobileLabel: 'Intraneural',
        level: 2
    },
    {
        code: 372468001,
        display: 'Intraocular route (qualifier value)',
        label: 'Intraocular',
        mobileLabel: 'Intraocular',
        level: 2
    },
    {
        code: 417255000,
        display: 'Intraosseous route (qualifier value)',
        label: 'Intraosseous',
        mobileLabel: 'Intraosseous',
        level: 2
    },
    {
        code: 419631009,
        display: 'Intraovarian route (qualifier value)',
        label: 'Intraovarian',
        mobileLabel: 'Intraovarian',
        level: 2
    },
    {
        code: 445771006,
        display: 'Intrapericardial route (qualifier value)',
        label: 'Intrapericardial',
        mobileLabel: 'Intrapericardial',
        level: 2
    },
    {
        code: 38239002,
        display: 'Intraperitoneal route (qualifier value)',
        label: 'Intraperitoneal',
        mobileLabel: 'Intraperitoneal',
        level: 2
    },
    {
        code: 372469009,
        display: 'Intrapleural route (qualifier value)',
        label: 'Intrapleural',
        mobileLabel: 'Intrapleural',
        level: 2
    },
    {
        code: 419810008,
        display: 'Intraprostatic route (qualifier value)',
        label: 'Intraprostatic',
        mobileLabel: 'Intraprostatic',
        level: 2
    },
    {
        code: 420201002,
        display: 'Intrapulmonary route (qualifier value)',
        label: 'Intrapulmonary',
        mobileLabel: 'Intrapulmonary',
        level: 2
    },
    {
        code: 419231003,
        display: 'Intrasinal route (qualifier value)',
        label: 'Intrasinal',
        mobileLabel: 'Intrasinal',
        level: 2
    },
    {
        code: 418418000,
        display: 'Intraspinal route (qualifier value)',
        label: 'Intraspinal',
        mobileLabel: 'Intraspinal',
        level: 2
    },
    {
        code: 372470005,
        display: 'Intrasternal route (qualifier value)',
        label: 'Intrasternal',
        mobileLabel: 'Intrasternal',
        level: 2
    },
    {
        code: 418877009,
        display: 'Intrasynovial route (qualifier value)',
        label: 'Intrasynovial',
        mobileLabel: 'Intrasynovial',
        level: 2
    },
    {
        code: 418586008,
        display: 'Intratendinous route (qualifier value)',
        label: 'Intratendinous',
        mobileLabel: 'Intratendinous',
        level: 2
    },
    {
        code: 418947002,
        display: 'Intratesticular route (qualifier value)',
        label: 'Intratesticular',
        mobileLabel: 'Intratesticular',
        level: 2
    },
    {
        code: 72607000,
        display: 'Intrathecal route (qualifier value)',
        label: 'Intrathecal',
        mobileLabel: 'Intrathecal',
        level: 2
    },
    {
        code: 417950001,
        display: 'Intrathoracic route (qualifier value)',
        label: 'Intrathoracic',
        mobileLabel: 'Intrathoracic',
        level: 2
    },
    {
        code: 447122006,
        display: 'Intratumor route (qualifier value)',
        label: 'Intratumor',
        mobileLabel: 'Intratumor',
        level: 2
    },
    {
        code: 418091004,
        display: 'Intratympanic route (qualifier value)',
        label: 'Intratympanic',
        mobileLabel: 'Intratympanic',
        level: 2
    },
    {
        code: 62226000,
        display: 'Intrauterine route (qualifier value)',
        label: 'Intrauterine',
        mobileLabel: 'Intrauterine',
        level: 2
    },
    {
        code: 445755006,
        display: 'Intravascular route (qualifier value)',
        label: 'Intravascular',
        mobileLabel: 'Intravascular',
        level: 2
    },
    {
        code: 418114005,
        display: 'Intravenous central route (qualifier value)',
        label: 'Intravenous central',
        mobileLabel: 'Intravenous central',
        level: 2
    },
    {
        code: 419993007,
        display: 'Intravenous peripheral route (qualifier value)',
        label: 'Intravenous peripheral',
        mobileLabel: 'Intravenous peripheral',
        level: 2
    },
    {
        code: 420287000,
        display: 'Intraventricular route - cardiac (qualifier value)',
        label: 'Intraventricular route - cardiac',
        mobileLabel: 'Intraventricular route - cardiac',
        level: 2
    },
    {
        code: 372471009,
        display: 'Intravesical route (qualifier value)',
        label: 'Intravesical',
        mobileLabel: 'Intravesical',
        level: 2
    },
    {
        code: 418401004,
        display: 'Intravitreal route (qualifier value)',
        label: 'Intravitreal',
        mobileLabel: 'Intravitreal',
        level: 2
    },
    {
        code: 127491008,
        display: 'Jejunostomy use',
        label: 'Jejunostomy use',
        mobileLabel: 'Jejunostomy use',
        level: 2
    },
    {
        code: 420185003,
        display: 'Laryngeal route (qualifier value)',
        label: 'Laryngeal',
        mobileLabel: 'Laryngeal',
        level: 2
    },
    {
        code: 447081004,
        display: 'Lower respiratory tract route (qualifier value)',
        label: 'Lower respiratory tract',
        mobileLabel: 'Lower respiratory tract',
        level: 2
    },
    {
        code: 420204005,
        display: 'Mucous fistula route (qualifier value)',
        label: 'Mucous fistula',
        mobileLabel: 'Mucous fistula',
        level: 2
    },
    {
        code: 420218003,
        display: 'Nasoduodenal route (qualifier value)',
        label: 'Nasoduodenal',
        mobileLabel: 'Nasoduodenal',
        level: 2
    },
    {
        code: 418441008,
        display: 'Orogastric route (qualifier value)',
        label: 'Orogastric',
        mobileLabel: 'Orogastric',
        level: 2
    },
    {
        code: 372473007,
        display: 'Oromucosal route (qualifier value)',
        label: 'Oromucosal',
        mobileLabel: 'Oromucosal',
        level: 2
    },
    {
        code: 418664002,
        display: 'Oropharyngeal route (qualifier value)',
        label: 'Oropharyngeal',
        mobileLabel: 'Oropharyngeal',
        level: 2
    },
    {
        code: 418851001,
        display: 'Paracervical route (qualifier value)',
        label: 'Paracervical',
        mobileLabel: 'Paracervical',
        level: 2
    },
    {
        code: 419165009,
        display: 'Paravertebral route (qualifier value)',
        label: 'Paravertebral',
        mobileLabel: 'Paravertebral',
        level: 2
    },
    {
        code: 428191002,
        display: 'Percutaneous route (qualifier value)',
        label: 'Percutaneous',
        mobileLabel: 'Percutaneous',
        level: 2
    },
    {
        code: 372474001,
        display: 'Periarticular route (qualifier value)',
        label: 'Periarticular',
        mobileLabel: 'Periarticular',
        level: 2
    },
    {
        code: 418722009,
        display: 'Peribulbar route (qualifier value)',
        label: 'Peribulbar',
        mobileLabel: 'Peribulbar',
        level: 2
    },
    {
        code: 447080003,
        display: 'Peridural route (qualifier value)',
        label: 'Peridural',
        mobileLabel: 'Peridural',
        level: 2
    },
    {
        code: 447052000,
        display: 'Periodontal route (qualifier value)',
        label: 'Periodontal',
        mobileLabel: 'Periodontal',
        level: 2
    },
    {
        code: 420047004,
        display: 'Periosteal route (qualifier value)',
        label: 'Periosteal',
        mobileLabel: 'Periosteal',
        level: 2
    },
    {
        code: 419762003,
        display: 'Peritendinous route (qualifier value)',
        label: 'Peritendinous',
        mobileLabel: 'Peritendinous',
        level: 2
    },
    {
        code: 418204005,
        display: 'Periurethral route (qualifier value)',
        label: 'Periurethral',
        mobileLabel: 'Periurethral',
        level: 2
    },
    {
        code: 447694001,
        display: 'Respiratory tract route (qualifier value)',
        label: 'Respiratory tract',
        mobileLabel: 'Respiratory tract',
        level: 2
    },
    {
        code: 418321004,
        display: 'Retrobulbar route (qualifier value)',
        label: 'Retrobulbar',
        mobileLabel: 'Retrobulbar',
        level: 2
    },
    {
        code: 372476004,
        display: 'Subconjunctival route (qualifier value)',
        label: 'Subconjunctival',
        mobileLabel: 'Subconjunctival',
        level: 2
    },
    {
        code: 419601003,
        display: 'Subgingival route (qualifier value)',
        label: 'Subgingival',
        mobileLabel: 'Subgingival',
        level: 2
    },
    {
        code: 1611000175109,
        display: 'Sublesional route (qualifier value)',
        label: 'Sublesional',
        mobileLabel: 'Sublesional',
        level: 2
    },
    {
        code: 416174007,
        display: 'Suborbital route (qualifier value)',
        label: 'Suborbital',
        mobileLabel: 'Suborbital',
        level: 2
    },
    {
        code: 419320008,
        display: 'Subtendinous route (qualifier value)',
        label: 'Subtendinous',
        mobileLabel: 'Subtendinous',
        level: 2
    },
    {
        code: 419894000,
        display: 'Surgical cavity route (qualifier value)',
        label: 'Surgical cavity',
        mobileLabel: 'Surgical cavity',
        level: 2
    },
    {
        code: 418813001,
        display: 'Surgical drain route (qualifier value)',
        label: 'Surgical drain',
        mobileLabel: 'Surgical drain',
        level: 2
    },
    {
        code: 419243002,
        display: 'Transcervical route (qualifier value)',
        label: 'Transcervical',
        mobileLabel: 'Transcervical',
        level: 2
    },
    {
        code: 45890007,
        display: 'Transdermal route (qualifier value)',
        label: 'Transdermal',
        mobileLabel: 'Transdermal',
        level: 2
    },
    {
        code: 446435000,
        display: 'Transendocardial route (qualifier value)',
        label: 'Transendocardial',
        mobileLabel: 'Transendocardial',
        level: 2
    },
    {
        code: 404815008,
        display: 'Transmucosal route (qualifier value)',
        label: 'Transmucosal',
        mobileLabel: 'Transmucosal',
        level: 2
    },
    {
        code: 446442000,
        display: 'Transplacental route (qualifier value)',
        label: 'Transplacental',
        mobileLabel: 'Transplacental',
        level: 2
    },
    {
        code: 447229005,
        display: 'Transtracheal route (qualifier value)',
        label: 'Transtracheal',
        mobileLabel: 'Transtracheal',
        level: 2
    },
    {
        code: 447227007,
        display: 'Transtympanic route (qualifier value)',
        label: 'Transtympanic',
        mobileLabel: 'Transtympanic',
        level: 2
    },
    {
        code: 418511008,
        display: 'Transurethral route (qualifier value)',
        label: 'Transurethral',
        mobileLabel: 'Transurethral',
        level: 2
    },
    {
        code: 419021003,
        display: 'Tumor cavity route (qualifier value)',
        label: 'Tumor cavity',
        mobileLabel: 'Tumor cavity',
        level: 2
    },
    {
        code: 419684008,
        display: 'Ureteral route (qualifier value)',
        label: 'Ureteral',
        mobileLabel: 'Ureteral',
        level: 2
    },
    {
        code: 420168000,
        display: 'Urostomy route (qualifier value)',
        label: 'Urostomy',
        mobileLabel: 'Urostomy',
        level: 2
    },
    {
        code: 18679011000001100,
        display: 'Inhalation',
        label: 'Inhalation',
        mobileLabel: 'Inhalation',
        level: 2
    },
    {
        code: 372475000,
        display: 'A route that begins around a nerve or nerves.',
        label: 'A route that begins around a nerve or nerves.',
        mobileLabel: 'A route that begins around a nerve or nerves.',
        level: 3
    },
    {
        code: 419874009,
        display: 'A route that begins beneath the mucous membrane.',
        label: 'A route that begins beneath the mucous membrane.',
        mobileLabel: 'A route that begins beneath the mucous membrane.',
        level: 3
    },
    {
        code: 418730005,
        display:
            'An intrajejunal route that begins through the nose and into the jejunum by means of a tube.',
        label: 'An intrajejunal route that begins through the nose and into the jejunum by means of a tube.',
        mobileLabel:
            'An intrajejunal route that begins through the nose and into the jejunum by means of a tube.',
        level: 3
    },
    {
        code: 419778001,
        display:
            'An intrapulmonary tract route that begins within the bronchus.',
        label: 'An intrapulmonary tract route that begins within the bronchus.',
        mobileLabel:
            'An intrapulmonary tract route that begins within the bronchus.',
        level: 3
    }
];

module.exports = codes.map((entry) => makeItem(entry));
